import { useState, useEffect } from 'react';
import GlobalSVG from '../../utils/GlobalSVG';
import LoaderWheel from '../LoaderWheel';
import API from '../../utils/API';
import Swal from 'sweetalert2';
import SelectOrType from '../SelectOrType';

const UtilityBillAccount = ({ item, tags, select, selected = false, setUtilities, coModels, readOnly = false }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [local, setLocal] = useState(item)
    const [newTag, setNewTag] = useState("")
    const [acceptable, setAcceptable] = useState(false)
    const [error, setError] = useState({})
    const [loading, setLoading] = useState(false)

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleCancelClick = () => {
        setLocal(item)
        setIsEditing(false);
    };

    const handleChange = (e) => {
        setLocal(p => {
            return { ...p, [e.target.name]: e.target.value }
        })
    }

    useEffect(() => {
        setLocal(item)
    }, [item])

    useEffect(() => {
        if (local.name.trim() !== "" && local.account_id.trim() !== "") setAcceptable(true)
        else setAcceptable(false)
    }, [local])

    const handleSaveClick = async () => {
        setLoading(true)
        const cancelToken = API.cancelToken();

        try {
            if (local.type !== 2 && !local.co_cost_model_id) {
                Swal.fire({
                    title: 'Emissions Model Missing',
                    text: 'Please select an emissions model before saving.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });
                return
            }
            if (local.id === null) {
                let payload = Object.fromEntries(Object.entries(local).filter(([k]) => ['building_id', 'name', 'type', 'account_id', 'co_cost_model_id', 'tags', 'site_id'].includes(k)));
                let newItem = await API.postUtilityAccount(cancelToken, payload)
                setUtilities(prev => {
                    let tempArr = JSON.parse(JSON.stringify(prev))
                    tempArr.splice(tempArr.length - 1, 1, newItem)
                    return tempArr
                })
            } else {
                let payload = Object.fromEntries(Object.entries(local).filter(([k]) => ['name', 'co_cost_model_id', 'tags'].includes(k)));
                await API.putUtilityAccount(cancelToken, payload, local.id)
                setUtilities(prev => {
                    let tempArr = JSON.parse(JSON.stringify(prev))
                    const index = tempArr.findIndex(account => account.id === item.id)
                    if (index === -1) return
                    tempArr.splice(index, 1, local)
                    return tempArr
                })
            }
            setIsEditing(false)

        } catch (err) {
            console.log(err)
            if (err.message === 'cancelling') return
            if (err.response && err.response.data) {
                if ('general' in err.response.data || 'message' in err.response.data) {
                    Swal.fire({
                        title: 'Error.',
                        text: err.response.data.general || err.response.data.message,
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#007b4e',
                    });
                } else {
                    setError(err.response.data)
                }
            }
        } finally {
            setLoading(false)
        }

    }

    const addTag = (e) => {
        let val = e.target.value.trim()
        if (!val) return
        setNewTag(e.target.value)
    }

    const updateTags = () => {
        if (local.tags.includes(newTag)) return
        setLocal(e => ({ ...e, tags: [...e.tags, newTag] }))
        setNewTag("")
    }

    const filterTags = (e) => {
        setLocal(prev => ({ ...prev, tags: prev.tags.filter(val => val !== e) }))
    }

    return (
        <div onClick={!isEditing ? () => select(item.id) : undefined} className={`w-[260px] ${selected ? "bg-[#99CaB8]" : "bg-[#FFF]"} border border-[gray] rounded-lg cursor-pointer shadow-[0_8px_8px_rgba(0,0,0,0.3)] transform transition-transform duration-200 hover:shadow-[0_12px_12px_rgba(0,0,0,0.3)] shadow-sm flex p-4`}>
            <div className="flex flex-col justify-center">
                <div className="flex flex-col items-end">
                    {loading ?
                        <LoaderWheel light={true} />
                        :
                        (isEditing ? (
                            <div className="flex">
                                {acceptable &&
                                    <button
                                        className="px-2 py-1 text-xs text-white font-medium rounded"
                                        onClick={handleSaveClick}
                                    >
                                        {GlobalSVG.check2()}
                                    </button>}
                                <button
                                    className="px-2 py-1 text-xs text-white font-medium rounded"
                                    onClick={handleCancelClick}
                                >
                                    {GlobalSVG.false()}
                                </button>
                            </div>
                        ) : (
                            !readOnly &&
                            <button onClick={handleEditClick} className="w-[28px] h-[28px]">
                                {GlobalSVG.edit("#007b4e")}
                            </button>
                        ))}
                </div>
                {error && error.name && <p className='text-xs text-[red]'>{error.name}</p>}
                <input
                    name="name"
                    placeholder="New Account Name"
                    type="text"
                    className={`hide-input-background w-full text-md font-semibold text-[gray] my-2 ${!isEditing ? 'cursor-pointer border-none' : ''}`}
                    value={local.name}
                    readOnly={!isEditing}
                    onChange={handleChange}
                    onClick={isEditing ? (e) => e.stopPropagation() : undefined}
                />
                <p className='text-xs font-bold text-[gray] mt-1'>Account ID</p>
                {error && error.account_id && <p className='text-xs text-[red]'>{error.account_id}</p>}
                <input
                    name="account_id"
                    placeholder="New Account ID"
                    type="text"
                    className={`hide-input-background w-full text-sm text-[gray] ${!isEditing ? 'cursor-pointer border-none' : ''}`}
                    value={local.account_id}
                    readOnly={!isEditing || local.id !== null}
                    onChange={handleChange}
                    onClick={isEditing ? (e) => e.stopPropagation() : undefined}
                />
                <p className='text-xs font-bold text-[gray] mt-2'>Site ID</p>
                {error && error.site_id && <p className='text-xs text-[red]'>{error.site_id}</p>}
                <input
                    name="site_id"
                    placeholder="Site ID"
                    type="text"
                    className={`hide-input-background w-full text-sm text-[gray] ${!isEditing ? 'cursor-pointer border-none' : ''}`}
                    value={local.site_id}
                    readOnly={!isEditing || local.id !== null}
                    onChange={handleChange}
                    onClick={isEditing ? (e) => e.stopPropagation() : undefined}
                />
                {local.type !== 2 && !readOnly &&
                    <div>
                        <p className='text-xs font-bold text-[gray] mt-2'>CO2 Model</p>
                        <select
                            onChange={handleChange}
                            className={`hide-input-background w-full text-sm text-[gray] mt-2 ml-[-3px] ${!isEditing ? 'cursor-pointer border-none' : ''}`}
                            disabled={!isEditing}
                            name="co_cost_model_id"
                            value={local.co_cost_model_id}
                            onClick={isEditing ? (e) => e.stopPropagation() : undefined}>
                            <option value="">Emissions Model</option>
                            {
                                coModels && Object.keys(coModels).map((m, ix) => (
                                    <option value={m}>{coModels[m]}</option>
                                ))
                            }
                        </select>
                    </div>
                }
                <div className='mt-2 text-xs font-bold text-[gray]'>Tags</div>
                <div className='overflow-auto h-[70px] w-full'>
                    <div className='flex flex-wrap max-h-[60px] max-w-[300px] items-center justify-start mt-2'>
                        {
                            local.tags && local.tags.map((e, ix) => (
                                <div className={`flex flex-nowrap items-center justify-center py-1 px-2 rounded mr-2 mb-2 text-sm shadow-[0_6px_6px_rgba(0,0,0,0.2)] ${selected ? 'bg-[white] text-[black]' : 'bg-[#99CaB8] text-[#FAFAFA]'}`}>
                                    <div key={ix + "tag"}>
                                        {e}
                                    </div>
                                    {isEditing &&
                                        <div className='ml-2' onClick={() => filterTags(e)}>
                                            {GlobalSVG.close("#000")}
                                        </div>}
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className='flex flex-nowrap items-center justify-start mt-2'>
                    {
                        isEditing &&
                        <SelectOrType
                            customClass="text-sm"
                            value={newTag}
                            options={tags}
                            disabled={!isEditing}
                            placeholder={"New Tag"}
                            name='tag'
                            onChange={addTag}
                            hideBlur={true} />
                    }
                    {
                        isEditing &&
                        <div className='py-1 px-3 rounded ml-2 bg-[#007b4e] text-[white]' onClick={updateTags}>
                            +
                        </div>
                    }
                </div>
            </div>
        </div >
    );
};

export default UtilityBillAccount;